import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { ProvedorSessao } from "./hooks/useAuth";
import { Toaster } from "./components/ui/sonner";
import "./styles.css";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const raiz = document.getElementById("root");
if (!raiz) throw new Error("Elemento #root não encontrado.");

createRoot(raiz).render(
  <StrictMode>
    <ProvedorSessao>
      <RouterProvider router={router} />
      <Toaster position="top-right" theme="light" richColors closeButton />
    </ProvedorSessao>
  </StrictMode>,
);
